/* eslint-disable react/no-unknown-property */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import '../../static/less/loyalty.less';
import '../../static/images/loading5.gif';
import '../../static/less/new_shopping_cart/login2.css';
import CloseIcon from '../icons/CloseIcon';
//import Checkbox from '../common/Checkbox';
import sandos4uWhite from '../../static/images/sandos4uWhite.png';
import { DEVICES } from '../../actions/Booking';
import RegisterReminderBlock from './RegisterReminderBlock';
import {
  setShowLastChanceToRegister, setLastChanceRegisterConfirmed, setShowLogin, setShowRegistration,
} from '../../actions/Loyalty';

class BookNowRegisterReminder extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  handleContinueWithoutLoyaltyClick = () => {
    this.props.dispatch(setShowLastChanceToRegister(false));
    this.props.dispatch(setShowLogin(false));
    this.props.dispatch(setShowRegistration(false));
    this.props.dispatch(setLastChanceRegisterConfirmed(true));
  };

  render() {
    return (
      <div className={'loyaltyLogin'}>
        <div className={'backdrop'} onClick={this.handleContinueWithoutLoyaltyClick}/>
          <div className={'content content2'} style={{ borderRadius: '15px' }}>
            <CloseIcon onClick={this.handleContinueWithoutLoyaltyClick}/>
            <div className="login-wrapper">
            <div className="loyaltyCenterImage">
              <img
                src={sandos4uWhite}
                alt="Tarifa garantizada"
              />
            </div>
            <div className="login-container">
              <RegisterReminderBlock/>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BookNowRegisterReminder.propTypes = {

};

BookNowRegisterReminder.contextTypes = {
  t: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  isMobile: state.booking.device === DEVICES.MOBILE,
  isTabletV: state.booking.device === DEVICES.TABLETV,
  isTabletH: state.booking.device === DEVICES.TABLETH,
  isDesktop: state.booking.device === DEVICES.DESKTOP,
});

export default connect(mapStateToProps)(BookNowRegisterReminder);
